/**
 * Tracks visibility of the "Now Playing" section on the home page.
 * When visible, the PlayBar hides to save vertical space on mobile.
 * When scrolled out of view, the PlayBar slides back in.
 */
import { useState, useEffect } from 'react';

let isVisible = false;
let setVisible: ((v: boolean) => void) | null = null;

export function useNowPlayingVisible() {
  const [visible, _setVisible] = useState(isVisible);

  useEffect(() => {
    setVisible = _setVisible;
    return () => {
      setVisible = null;
    };
  }, []);

  return visible;
}

export function useTrackNowPlaying() {
  useEffect(() => {
    return () => {
      isVisible = false;
      setVisible?.(false);
    };
  }, []);

  return (node: HTMLElement | null) => {
    if (!node) return;

    new IntersectionObserver(([entry]) => {
      isVisible = entry.isIntersecting;
      setVisible?.(isVisible);
    }).observe(node);
  };
}
